import React from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import TimeAgo from 'javascript-time-ago'

import ro from 'javascript-time-ago/locale/ro'

TimeAgo.addDefaultLocale(ro)

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);